import { useEffect, useState } from 'react';
import { getStudentGroups } from '../../../../services/StudentService';
import { useGetRemoteServiceWrapper } from '../../../hooks/RemoteServiceHooks';
import Logger from '../../../../utils/Logger';

/**
 * Fetches the teacher's student groups for the Class Report "Student Group" dropdown.
 *
 * The raw groups (including each group's `students` array) are kept so that, once
 * wired to the search, we can merge the student ids of the selected groups and pass
 * them to getClassReport as studentIds=1,2,3. The selector-shaped options are derived
 * from the raw groups.
 */
export const useStudentGroups = () => {
  const { loading, callRemoteServiceWrapper } = useGetRemoteServiceWrapper();
  const [studentGroups, setStudentGroups] = useState([]);

  const loadStudentGroups = async () => {
    try {
      await callRemoteServiceWrapper(async () => {
        const result = await getStudentGroups();
        setStudentGroups(result.data || []);
      });
    } catch (e) {
      Logger.logWhenDebugModeIsOn(e);
    }
  };

  useEffect(() => {
    loadStudentGroups();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const studentGroupOptions = studentGroups.map((g) => ({
    key: g.id,
    value: g.id,
    name: g.name,
  }));

  return {
    loading,
    studentGroups,
    studentGroupOptions,
  };
};
